import { useNavigate } from "react-router";
import { PrimaryCTAButton } from "./quickRound/CTAButtonComponents";

export default function PageNotFound404() {
  const navigate = useNavigate();
  return (
    <>
      <main className="grid h-screen place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-[#E85936]">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <PrimaryCTAButton
              event-name="Go Back Home From 404"
              onClick={() => {
                navigate("/landing/dashboard");
              }}
            >
              Go back home
            </PrimaryCTAButton>
          </div>
        </div>
      </main>
    </>
  );
}
